<template>
	<div class="techonlogy">
		<div class="techonlogy-top">
			<img src="/static/img/fuwu.jpg"/>
			<div class="bannerMask"><div></div></div>
			<div class="com-tit">
				<span>
					<img src="/static/img/fuwuicon.png"/><b>业务中心</b>
				</span>
				<p>致力于为政府、学校、医疗、公共事业、生产企业等各行业提<br />
供专业的信息化服务</p>
			</div>
		</div>
		<div class="tech-detail">
			<div class="tech-top-top">
				<h4>{{tech[chalid].title}}</h4>
				<div class="tech-line">
					
				</div>
			</div>
			<div class="techinfo" v-if="chalid == 0 ">
					<p class="com-content"> 公司服务领域分为三大块：</p> 
					<div class="tech-singleimg">
						<img :src="techimg[0].imgsrc"/>
					</div>
					<h4 class="small-tit">{{techimg[0].smalltit}}</h4>
					<p>系统集成（SI，System Integration），我们在系统工程科学方法的指导下，经过专业技术的不断进步和多年施 工经验的积累，能为您提供智能弱电系统
						集成、网络安全系统集成、数据中心与云平台等三大项目和20个子系统的专业服务。
					</p> 
					<div class="tech-singleimg">
						<img :src="techimg[1].imgsrc"/>
					</div>
					<h4 class="small-tit">{{techimg[1].smalltit}}</h4>
					<p>软件与数据服务（Software and data services），思程科技是以自主知识产权产品开发为核心的双软企业，我公司采用了CMMI管理模式体系以及国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件。
					</p>
					<div class="tech-singleimg">
						<img :src="techimg[2].imgsrc"/>
					</div>
					<p>软件（SAAS）即服务是行业的发展趋势，提供应用类的软件服务是公司的发展方向，公司以软件开发为基础，向用户提供全方向的信息化业务方案
					</p>
					<div class="tech-singleimg">
						<img :src="techimg[3].imgsrc"/>
					</div>
					<h4 class="small-tit">{{techimg[2].smalltit}}</h4>
					<p>IT运维服务 (IT operation and maintenance services) ，思程科技以专业的技术力量和运维团队为客户提 供IT领域全面的咨询、实施、运维、迁移、培训五大类服务。
					</p>
					<div class="tech-singleimg">
						<img :src="techimg[4].imgsrc"/>
					</div>
            </div>
            <!--业务模式-->
            <div class="techinfo" v-if="chalid == 1 ">
					<p class="com-content"> 公司以信息化技术为基础，深入行业需求，服务于各行业，以提供相关行业的信息化解决方案为整体方向，以项目建设、产品开发、项目运营等形式拓展业务。</p> 
					<h4 class="small-tit">{{yewu[0].smalltit}}</h4>
					   <p>由专业的信息化项目经理落实项目建设，全程项目监管勘查、设计、施工、维护</p> 
					<div class="tech-singleimg">
						<img :src="yewu[0].imgsrc" style="width: 35%;">
					</div>
					<h4 class="small-tit">{{yewu[1].smalltit}}</h4>
					<p>以市场需求为导向，结合相关的行业经验，公司不断推进产品开发工作，以优质产品赢取市场。
					</p> 
					<div class="tech-singleimg">
						<img :src="yewu[1].imgsrc">
					</div>
					<h4 class="small-tit">{{yewu[2].smalltit}}</h4>
					<p>根据用户的业务需求，发挥公司的技术优势与资本能力，承担相关的信息化建设并负责具体运营，达到共赢的目的。
					</p>
					<div class="tech-singleimg">
						<img :src="yewu[2].imgsrc" style="width: 36%;">
					</div>
            </div>
            <!--技术领域-->
            <div class="techinfo" v-if="chalid == 2 ">
					<p class="com-content"> 公司主要涉及的技术领域有（1）弱电+网络通讯（2）数据与安全（3）云技术（4）物联网（5）应用软件</p> 
					<h4 class="small-tit">{{jishu[0].smalltit}}</h4>
					<div class="tech-singleimg">
						<img :src="jishu[0].imgsrc" style="width: 45%;">
					</div>
					<h4 class="small-tit">{{jishu[1].smalltit}}</h4>
					<div class="tech-singleimg">
						<img :src="jishu[1].imgsrc" style="width: 60%;">
					</div>
					<h4 class="small-tit">{{jishu[2].smalltit}}</h4>
					<div class="tech-singleimg">
						<img :src="jishu[2].imgsrc" style="width: 60%;">
					</div>
					<h4 class="small-tit">{{jishu[3].smalltit}}</h4>
					<p class="com-content"> 顾名思义，物联网就是物物相连的互联网。这有两层意思：其一，物联网的核心和基础仍然是互联网，是在互
					联网基础上的延伸和扩展的网络；其二，其用户端延伸和扩展到了任何物品与物品之间，进行信息交换和通信，也就
					是物物相息。物联网通过智能感知、识别技术与普适计算等通信感知技术，广泛应用于网络的融合中，也因此被称
					为继计算机、互联网之后世界信息产业发展的第三次浪潮。物联网是互联网的应用拓展，与其说物联网是网络，不
					如说物联网是业务和应用。因此，应用创新是物联网发展的核心，以用户体验为核心的创新2.0是物联网发展的灵魂。
					</p>
					<h4 class="small-tit">{{jishu[4].smalltit}}</h4>
					<p class="com-content"> 应用软件开发，思程科技是以自主知识产权产品开发为核心的双软企业，我司采用了CMMI管理模式体系
					以上国际上先进、成熟的开发工具和语言，开发了许多满足客户实际需求的应用软件，应用于政府、民政、医疗、金融等各行业，用户反应良好。
					</p>
					<p class="com-content"> 思程科技的软件研发团队是由一批技术能力强、项目经验丰富的软件人才组成，具有多元化的技术路线，涵盖各主流开发
						语言，在.net和JAVA方面都有着丰富的项目和产品开发经验
					</p>
					<div class="tech-singleimg">
						<img :src="jishu[4].imgsrc">
					</div>
            </div>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'techonlogy',
		data () {
			return {
				tech : [
				{id : 0 , imgsrc : '/static/img/fuwu.jpg' , title : '服务领域' },
				{id : 1 , imgsrc : '/static/img/fuwu.jpg' , title : '业务模式' },
				{id : 2 , imgsrc : '/static/img/fuwu.jpg' , title : '技术领域' },
				],
				techimg : [
				{id : 0 , imgsrc : '/static/img/serve1 (1).png' , smalltit : '系统集成'},
				{id : 1 , imgsrc : '/static/img/11serve1 (1).png' , smalltit : '软件与数据服务'},
				{id : 2 , imgsrc : '/static/img/sc-soft-img2.png' , smalltit : 'IT运维服务'},
				{id : 3 , imgsrc : '/static/img/serve1 (2).png' , smalltit : ''},
				{id : 4 , imgsrc : '/static/img/serve1 (3).png' , smalltit : ''},
				],
				yewu :[
				{id : 0, imgsrc : '/static/img/yewumodx.png' , smalltit : '项目建设'},
				{id : 1, imgsrc : '/static/img/yewumodp.png' , smalltit : '产品开发'},
				{id : 2, imgsrc : '/static/img/yewumodz.png' , smalltit : '项目合作运营'},
				],
				jishu :[
				{id : 0, imgsrc : '/static/img/jsly.png' , smalltit : '弱电+网络通讯'},
				{id : 1, imgsrc : '/static/img/jsly2.png' , smalltit : '数据与安全'},
				{id : 2, imgsrc : '/static/img/jsly3.png' , smalltit : '云技术'},
				{id : 3, imgsrc : '/static/img/yewumodz.png' , smalltit : '物联网'},
				{id : 4, imgsrc : '/static/img/jsly4.png' , smalltit : '应用软件'},
				],
				chalid : 0,
				
			}
		},
		mounted(){
			this.getID()
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
		},
	}
</script>

<style>
	.techonlogy{
		width: 100%;
		position: relative;
		clear: both;
		overflow: hidden;
	}
	.tech-detail{
		width: 80%;
		margin: 0px auto 60px;
		position: relative;
		clear: both;
		text-align: left;		
	}
	.tech-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}
	.techonlogy-top {
		margin-top: -3vw;
	}	
	.techonlogy-top img{
		width: 100%;
	}
	.tech-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
	}
	.com-tit{
		position: relative;
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.tech-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}	
	.techinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.techinfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.techinfo img{
		text-align: center;
	}
	.tech-singleimg{
		text-align: center;
		position: relative;
	}
	.tech-singleimg img{
		margin-top: 40px;
	
	}
	.tech-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 50px auto 0;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
	}
</style>


// WEBPACK FOOTER //
// src/components/technology.vue